// extracted by mini-css-extract-plugin
export default {"forms":"profile_forms_GhUk5","help":"profile_help_fONLg"};